import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";
import { SharedModule } from "../../shared/modules/shared.module";
import { Location } from '@angular/common';
import { Router } from "@angular/router";

type NotFoundStateType = {
  returnTo: string,
  queryParams: Record<string, string>
}
@Component({
  selector: "app-not-found",
  imports: [SharedModule, TranslatePipe],
  templateUrl: "./not-found.component.html",
  styleUrl: "./not-found.component.scss",
})
export class NotFoundComponent {
  protected mailToLink = `mailto:${environment.supportEmail}`;
  private readonly _state?: NotFoundStateType

  constructor(private _location: Location, private _router: Router) {
    const navigation = this._router.getCurrentNavigation();
    this._state = navigation?.extras.state as NotFoundStateType;
  }

  goHome() {
    if (this._state?.returnTo) {
      this._router.navigate([this._state?.returnTo], { queryParams: this._state.queryParams })
    }
    else {
      this._location.back();
    }
  }
}
